const ITEMS = [
  "TROTTINETTES FUSÉES",
  "GRAFFITI SUR MESURE",
  "RÉPARATION SMARTPHONE",
  "AUTORADIO & HI-FI",
  "SECOND ŒUVRE",
  "RÉPARATION PC",
  "E-MOBILITÉ",
  "COVOITURAGE",
  "ACCOMPAGNEMENT",
];

export const Marquee = () => (
  <div
    className="relative border-y border-line bg-panel/70 py-5 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee items-center">
      {["first", "repeat"].flatMap((copy) => ITEMS.map((item, i) => (
        <span key={`${copy}-${item}`} className="flex items-center" aria-hidden={copy === "repeat"}>
          <span
            className={`font-display uppercase text-2xl sm:text-3xl tracking-wide px-6 ${
              i % 2 === 0 ? "text-slate-100" : "text-outline"
            }`}
          >
            {item}
          </span>
          <span className="text-pink-500 text-lg" aria-hidden="true">
            ●
          </span>
        </span>
      )))}
    </div>
  </div>
);
